<script setup>
import { ref} from 'vue'
import { useI18n } from 'vue-i18n';
const { locale } = useI18n();
let location = ref(locale.value);

</script>
<template>
    <div class="bad-page container">
        <div class="bad-page-content">
            <div class="bad-page-content-wrapper">
                <div class="bad-page-inner">
                    <div class="bad-page-image">
                        <div class="block-letter contain">
                            4
                        </div>
                        <div class="block-img contain" >
                            <img src="/assets/bad_page/404.png" />
                        </div>
                        <div class="block-letter contain secondary">
                            4
                        </div>
                    </div>
                    <div class="bad-page-block">
                        <div class="bad-page-block-wrapper">
                            <div class="title">
                                {{ $t('bad_page.title') }}
                            </div>
                            <div class="subtitle">
                                {{ $t('bad_page.subtitle') }}
                            </div>
                            <div class="link">
                                <div class="link-btns">
                                    <router-link :to="`/${location}`" class="custom-btn">
                                        {{ $t('bad_page.link') }}
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
    .bad-page {
        .bad-page-content {
            display: flex;
            flex-direction: column;
            justify-content: center;
            padding-top: 100px;
            padding-bottom: 200px;
            .bad-page-content-wrapper {
                width: 100%;
                margin: 0 auto;
                border-radius: 40px;
                padding-bottom: 55px;
                display: flex;
                justify-content: center;
                .bad-page-inner {
                    max-width: 600px;
                    .bad-page-image {
                        display: flex;
                        justify-content: center;
                        
                        .block-img {
                            max-width: 250px;
                            padding-top: 60px;
                            margin-left: 10px;
                            img {
                                width: 100%;
                            }
                        }
                        .block-letter {
                            font-size: 250px;
                            color: #c8ccd2;
                            line-height: 1px;
                            padding-top: 170px;
                            left: -30px;
                        }
                        .contain{
                            margin-right: -25px;
                        }
                    }
                    .bad-page-block {
                        display: flex;
                        justify-content: center;
                        flex-direction: column;
                        .title {
                            font-size: 30px;
                            font-family: 'CircularStd-Black';
                            letter-spacing: -1.85px;
                        }
                        .subtitle {
                            font-size: 20px;
                            letter-spacing: -1.1px;
                        }
                        .link {
                            padding-top: 50px;
                            .link-btns {
                                max-width: 175px;
                                width: auto;
                                a {
                                    display: block;
                                    padding: 10px 30px;
                                    text-decoration: none;
                                    text-align: center;
                                }
                            }
                        }
                        
                    }
                }
            }
        }
    }
    @media (max-width: 1000px) {
        .bad-page {
            .bad-page-content {
                .bad-page-content-wrapper {
                    .bad-page-inner {
                        .bad-page-image {
                            .block-letter {
                                font-size: 200px;
                                left: 6px;
                            }
                            .block-img {
                                max-width: 230px;
                            }
                        }
                    }
                }
            }
        }
    }
    @media (max-width: 500px) {
        .bad-page {
            .bad-page-content {
                .bad-page-content-wrapper {
                    .bad-page-inner {
                        .bad-page-image {
                            gap: 5px;
                            img{
                                margin-left: 0px;
                            }
                            .block-letter {
                                left: -7px;
                            }
                        }
                    }
                }
            }
        } 
    }
    @media (max-width: 400px) {
        .bad-page {
            .bad-page-content {
                .bad-page-content-wrapper {
                    .bad-page-inner {
                        .bad-page-image {
                            .block-letter {
                                font-size: 120px;
                                left: 1px;
                            }
                            .block-img {
                                max-width: 140px;
                                padding-top: 98px;
                            }
                        }
                        .bad-page-block {
                            .title {
                                font-size: 20px;
                            }
                            .subtitle {
                                font-size: 15px;
                                max-width: 265px;
                            }
                            .link {
                                display: flex;
                                justify-content: center;
                            }
                        } 
                    }
                }
            }
            .bad-page-block-wrapper {
                text-align: center;
            }
        }
    }
</style>